import { IngresoInicial, ProfilePreferences } from '@scap/profile/models/profile.model'

export const PROFILE_ROUTES = {
  MAIN: '/asistencia/profile',
}

export const STORAGE_PREFERENCIAS_PERFIL = 'scap-perfil-preferencias'

export const INGRESOS_INICIALES_LIST: IngresoInicial[] = [
  { ruta: '/atajos', titulo: 'Home', descripcion: 'Accesos rápidos', icono: 'fa-house' },
  { ruta: '/asistencia/attendance/modern', titulo: 'Marcar asistencia', descripcion: 'Directo al marcado', icono: 'fa-fingerprint' },
  { ruta: '/asistencia/attendance', titulo: 'Asistencia', descripcion: 'Lista de marcaciones', icono: 'fa-clipboard-user' },
  { ruta: '/asistencia/employee', titulo: 'Personal', descripcion: 'Lista de personal', icono: 'fa-users' },
  { ruta: '/asistencia/reports', titulo: 'Reportes', descripcion: 'Reportes de asistencia', icono: 'fa-file-lines' },
]

export const PREFERENCIAS_DEFECTO: ProfilePreferences = {
  codper: '',
  nomper: '',
  swautomar: true,
  initroute: INGRESOS_INICIALES_LIST[0].ruta,
  disabledPersonal: false,
}

export const ROLES_DESCRIPCION: Record<number, string> = {
  1: 'Usuario',
  2: 'Funcional',
  3: 'Administrador',
  4: 'API',
  5: 'Desarrollador',
  6: 'Soporte',
  7: 'Funcional masivo',
}
